import { Component, ChangeDetectorRef } from '@angular/core';

import { ModalComponent } from '../modal/modal.component';
import { BaseMenuComponent } from './base.menu';
import { PeopleService } from '../shared/services';

@Component({
    templateUrl: './point.menu.html',
    standalone: false
})
export class PointMenuComponent extends BaseMenuComponent {
  public showHelpText = true;
  public currentPerson: any;

  constructor(public modal: ModalComponent, private cdf: ChangeDetectorRef, private peopleService: PeopleService) {
    super(modal);
    this.peopleService.getCurrent().subscribe((res) => (this.currentPerson = res));
  }

  updateShowHelpText(showHelpText: boolean) {
    this.showHelpText = showHelpText;
    this.cdf.detectChanges();
  }
}
